import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getFromAddress } from 'owa-mail-compose-store/lib/utils/getFromAddresses';
import { ComposeViewState } from 'owa-mail-compose-store';

export const getFrom = (viewState: ComposeViewState) => (): EmailAddressWrapper => {
    return viewState.fromViewState && viewState.fromViewState.from
        ? viewState.fromViewState.from.email
        : getFromAddress();
};
